import o from"./loopCreate.js";import r from"./loopFix.js";import p from"./loopDestroy.js";const t={loopCreate:o,loopFix:r,loopDestroy:p};export{t as default};
//# sourceMappingURL=index.js.map
